import { observer } from 'mobx-react';
import React, { Component } from 'react';
import Text from '../../../clinical/clinical-text';
import type { RadioButtonGroupExplanationProps } from '../interfaces';

@observer
class RadioButtonGroupExplanation extends Component<RadioButtonGroupExplanationProps> {
  render() {
    const { other, active } = this.props;
    if (other !== 'Allowed with Explanation' || !active) {
      return null;
    }

    const { valueOther, onChangeOther, inline } = this.props;

    return (
      <div className={'yes-no-details'}>
        <Text
          value={valueOther}
          onChange={onChangeOther}
          label={'Details'}
          hintText={'Please explain the `Other` answer.'}
          inline={inline}
          required={true}
        />
      </div>
    );
  }
}

export default RadioButtonGroupExplanation;
